/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HeroBannerSettingsImageWidth = "full" | "half" | "%future added value";
export type HpRespSharedHeroBanner_promoItem = {
    readonly cmsId: number | null;
    readonly imageUrl?: string | null;
    readonly imageHeight?: string | null;
    readonly imageWidth?: string | null;
    readonly mobileImageHeight?: string | null;
    readonly mobileImageWidth?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly linkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_linkData">;
    };
    readonly heroBannerSettings: {
        readonly contentPosition: string | null;
        readonly backgroundColor: string | null;
        readonly bannerImageWidth: HeroBannerSettingsImageWidth | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_heroBannerSettings">;
    } | null;
    readonly cta: string | null;
    readonly isFullBleedImage: boolean | null;
    readonly format: CmsHomepageBannerFormatEnumType | null;
    readonly " $refType": "HpRespSharedHeroBanner_promoItem";
};
export type HpRespSharedHeroBanner_promoItem$data = HpRespSharedHeroBanner_promoItem;
export type HpRespSharedHeroBanner_promoItem$key = {
    readonly " $data"?: HpRespSharedHeroBanner_promoItem$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSharedHeroBanner_promoItem">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespSharedHeroBanner_promoItem",
  "type": "PromoItem",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cmsId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "heroBannerSettings",
      "storageKey": null,
      "args": null,
      "concreteType": "HeroBannerSettingsType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "contentPosition",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "backgroundColor",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "bannerImageWidth",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_heroBannerSettings",
          "args": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFullBleedImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageWidth",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageUrl",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ca209e37ad7d6f175fec5ba992a7dc71';
export default node;
